const initialState = {
  loading: false,
  count: 0,
  search:"",
  title:"",
  snackbar: {
    show: false,
    text: "",
    color: ""
  }
};

export const common = {
  namespaced: true,
  state: initialState,
  mutations: {
    setLoading(state, loading) {
      state.loading = loading;
    },
    setSearch(state, search) {
      state.search = search;
    },
    setTitle(state,title){
      state.title = title;
    }
  }
};
